import { cn } from "@/lib/utils";
import { Spinner } from "../ui/spinner";

interface WaveformVisualizerProps {
  levels?: number[];
  isThinking?: boolean;
  className?: string;
}

export const WaveformVisualizer = ({
  levels = [],
  isThinking = false,
  className,
}: WaveformVisualizerProps) => {
  if (isThinking) {
    return (
      <div
        className={cn(
          className,
          "rounded-2xl border border-border bg-muted/40 flex items-center justify-center relative"
        )}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative flex h-28 w-full flex-col justify-center rounded-2xl border border-border bg-muted/40 px-12 py-4",
        className
      )}
    >
      <div className="flex h-full items-center justify-center gap-[6px]">
        {levels.map((level, index) => {
          const targetHeight = Math.max(level * 180, 30);
          const height = Math.min(targetHeight, 100);
          const opacity = Math.max(level * 1.5, 0.3);
          return (
            <div
              key={index}
              className="flex-1 rounded-full bg-foreground/70 transition-[height,opacity] duration-500 ease-out"
              style={{
                height: `${height}%`,
                opacity,
                maxWidth: "12px",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
